import { StyleObj } from '../../@types';
import { GOLA_HEADER_HEIGHT } from '../../config/skinRegistry';
import { SkinStylesMap } from '../../hooks/useSkinStyles';
import { SKIN } from '../../types/enums';

const makeDefaultStyles = (success: boolean): StyleObj => ({
  username: {
    display: {
      xs: 'none',
      md: 'block',
    },
  },
  balance: {
    fontSize: { xs: 9, md: 12 },
    textAlign: 'right',
  },
  menuContainer: {
    mt: 2,
    '& .MuiPaper-root': {
      width: 360,
      backgroundColor: 'neutral.25',
      color: 'neutral.800',
    },
    '& .MuiList-root': {
      py: 0,
    },
  },
  balanceContainer: {
    p: 2,
    backgroundColor: 'neutral.50',
    borderBottom: '1px solid',
    borderColor: 'neutral.100',
    minHeight: 36,
    '&:hover': { backgroundColor: 'neutral.200' },
  },
  menuItem: {
    py: 1.5,
    backgroundColor: 'neutral.25',
    ':hover': {
      border: 'none',
    },
  },
  copyContainer: {
    p: 2,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    backgroundColor: success ? 'success.light' : 'neutral.50',
    '&:hover': {
      backgroundColor: success ? 'success.light' : 'neutral.100',
    },
  },
  copyText: {
    color: success ? 'success.contrastText' : 'inherit',
  },
});

const makeGolaStyles = (success: boolean): StyleObj => ({
  ...makeDefaultStyles(success),
  username: {
    display: 'none',
  },
  menuContainer: {
    mt: 2,
    '& .MuiPaper-root': {
      width: 360,
      backgroundColor: 'neutral.100',
      color: 'neutral.800',
    },
    '& .MuiList-root': {
      py: 0,
    },
  },
  menuPaper: {
    position: 'fixed !important',
    right: '0 !important',
    top: `${GOLA_HEADER_HEIGHT}px !important`,
    left: 'auto !important',
  },
  balanceContainer: {
    px: 2,
    py: 1.25,
    backgroundColor: 'neutral.50',
    borderBottom: '1px solid',
    borderColor: 'neutral.200',
    minHeight: 36,
    '&:hover': { backgroundColor: 'neutral.50' },
    '& p': {
      color: 'neutral.400',
      fontSize: 12,
      fontWeight: 400,
    },
    '& span': {
      fontSize: 18,
      fontWeight: 400,
      color: 'neutral.600',
    },
  },
  menuItem: {
    height: 44,
    py: 1.5,
    backgroundColor: 'neutral.100',
    borderBottom: '1px solid',
    borderColor: 'neutral.200',
    ':hover': {
      border: 'none',
    },
    '& p': {
      color: 'neutral.400',
      fontSize: 15,
      fontWeight: 400,
    },
  },
  languageMenuItem: { display: 'none' },
  divider: {
    display: 'none',
  },
  copyContainer: {
    px: 2,
    py: 1,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    backgroundColor: success ? 'success.light' : 'neutral.100',
    borderBottom: '1px solid',
    borderColor: 'neutral.200',
    '&:hover': {
      backgroundColor: success ? 'success.light' : 'neutral.100',
    },
  },
  copyText: {
    p: '2px',
  },
  copyLabel: {
    fontSize: 12,
    color: success ? 'success.contrastText' : 'neutral.400',
  },
  copyId: {
    fontSize: 18,
    fontWeight: 400,
    color: success ? 'success.contrastText' : 'neutral.600',
  },
});

export const getAgentAccountMenuSkinStyles = (success: boolean): SkinStylesMap<StyleObj> => ({
  [SKIN.BET365]: makeDefaultStyles(success),
  [SKIN.GOLA]: makeGolaStyles(success),
});
